import SiderTrigger from './sider_trigger.vue';

export default SiderTrigger;
